import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ClearInternalTransferState, ClearSelectedAccount, ClearTriageState } from '@store/actions';
import { ClearStateAndStorage } from '@store/index';
import { switchMap } from 'rxjs';

@Injectable()
export class SessionStorageEffects {
  constructor(private actions$: Actions) {}

  ClearStateAndStorage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClearStateAndStorage),
      switchMap(() => {
        return [ClearTriageState(), ClearInternalTransferState(), ClearSelectedAccount()];
      }),
    ),
  );
}
